import { forwardRef } from 'react'
import type { AccessibilityRole } from 'react-native'

import * as S from './label.styles'

import {
  DisplayNames,
  type ScopedProps,
  useInputMultiSelectContext,
} from '../../input-multi-select.context'

type InputMultiSelectLabelProps = {
  children: React.ReactNode
  testID?: string
}

type AccessibilityPropsForLabelType = {
  accessible: boolean
  accessibilityRole: AccessibilityRole
  accessibilityLabel: string
}

export const InputMultiSelectLabel = forwardRef<
  React.ElementRef<typeof S.ContentText>,
  InputMultiSelectLabelProps
>((externalProps, ref) => {
  const { __scopeInputMultiSelect, ...props } =
    externalProps as ScopedProps<InputMultiSelectLabelProps>

  const { size, isDisabled, isReadOnly } = useInputMultiSelectContext(
    DisplayNames.LABEL,
    __scopeInputMultiSelect
  )

  const accessibilityPropsForLabel: AccessibilityPropsForLabelType = {
    accessible: true,
    accessibilityRole: 'text',
    accessibilityLabel: String(props.children),
  }

  const propsStates = {
    size,
    isDisabled,
    isReadOnly,
  }

  return (
    <S.Container {...accessibilityPropsForLabel}>
      <S.ContentText {...props} {...propsStates} ref={ref} />
    </S.Container>
  )
})

InputMultiSelectLabel.displayName = DisplayNames.LABEL
